<p>
  pre-check-in works!
</p>
